<template>
    <div class="line_container">
        <div class="line_left">
            <img :src="icon" alt="" style="width:32rem;height:32rem;margin-right:10rem" />
            <div>{{title}}</div>
        </div>
        <div class="line_data">{{data}} <span style="font-size:18rem">{{unit}}</span></div>
    </div>
</template>

<script>
    export default {
        name: "lineitem",
        props: ['icon', 'title', 'data', 'unit'],
    }
</script>

<style lang="less" scoped>
    .line_container {
        .w(457);
        .h(80);
        padding-left: 8rem;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;

        .line_left{
            font-size: 18rem;
            color: #666;
            display: flex;
        }

        .line_data{
            color: rgba(13, 148, 255, 1);
            font-size: 24rem;
            font-weight: bold;
        }
    }
</style>